const userPayment = {
  userPayments: 'Платежі адміністратора',
  showing: 'показано',
  userPaymentsOf: 'платежі',
  noUserPaymentsFound: 'Платежі користувача не знайдено',
  table: {
    bonusPayment: 'Бонусний платіж',
    regularPayment: 'Звичайний платіж'
  },
  actionsDropdown: {
    edit: 'Редагувати платіж',
    delete: 'Видалити платіж',
    editInvoice: 'Редагувати рахунок-фактуру',
    deleteInvoice: 'Видалити рахунок-фактуру',
  },
  tableDropdown: {
    quickActions: 'Швидкі дії',
    refresh: 'Оновити',
    exportUserPayments: 'Експортувати',
    exportUserPaymentsCurrent: 'Експортувати поточний',
  },
  modal: {
    editPayment: 'Редагувати платіж',
    email: 'Електронна пошта',
    amount: 'Сума',
    date: 'Дата',
    paymentType: 'Тип платежу',
    paymentDetails: 'Інформація про платіж',
    successDelete: 'Платіж успішно видалено',
    invoiceUpdated: 'Рахунок-фактуру успішно оновлено',
    invoiceDeleted: 'Рахунок-фактуру успішно видалено',
    successUpdate: 'Платіж успішно оновлено',
  }
};

export default userPayment;
